import {TestRow} from '@/services/auditService/interface/wp-row';

export function countFilledTestRows(rows: TestRow[] | undefined | null): number {
    return (rows || []).filter((row) => {
        const hasText = (row.invNo || '').trim() !== '' || (row.description || '').trim() !== '';
        const hasDate = !!row.date;
        const hasAmount = row.amount !== undefined && row.amount !== null && row.amount !== '';
        return hasText || hasDate || hasAmount;
    }).length;
}
